import { Appointment } from "./models";

export default class Api {
    public static addAppointment(appointment: Appointment): Promise<void> {
        return new Promise(async (resolve, reject) => {
            try {
                
                const response = await fetch(`${process.env.REACT_APP_API_URL}/add-appointment`,
                    {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json',
                            // 'X-API-Key': process.env.REACT_APP_API_KEY || ""
                        },
                        body: JSON.stringify(appointment)
                    }
                );

                if(response.ok) {
                    const data = await response.json();
                    console.log(data);
                    resolve();
                }

            } catch (error) {
                console.log(error);
                reject(error);
            }
        })
    }
}